import * as React from "react";
import styled, { css } from "../../../styled/index";
const stopPropagation = (e) => e.stopPropagation();
const SwitchWrapper = styled("div") `
  position: relative;
  display: inline-block;
  label {
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
  }
`;
const SwitchInput = styled("input") `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
  font-size: 0;
  appearance: none;
`;
const SwitchLabel = styled("label") `
    display: block;
    position: relative;
    pointer-events: none;
    cursor: none!important;
    outline: none;
    user-select: none;
    margin: 0;
    padding: 2px;
    width: 50px;
    height: 24px;
    border-radius: 30px;
    background-color: ${({ labelColor }) => labelColor ? labelColor : '#dddddd'};
    transition: background 0.4s;
    &:before, &:after {
      display: block;
      position: absolute;
      content: "";
    }
    &:before {
      top: 2px;
      left: 2px;
      bottom: 2px;
      right: 2px;
      background: ${({ theme }) => theme.input.background};
      border-radius: 30px;
      transition: background 0.4s;
    }
    &:after {
      top: 4px;
      left: 4px;
      bottom: 4px;
      background-color: ${({ labelColor }) => labelColor ? labelColor : '#dddddd'};
      border-radius: 30px;
      transition: margin 0.4s, background 0.4s;
      width: 16px;
    }

    ${(props) => props.variant === 'black' ? css `
    background: #4B4F5E;
    &:after {
      background-color: #4B4F5E;
    }
  ` : null}

    ${(props) => props.checked ? css `
      background: ${props.theme.colors.primary};
      &:after {
        margin-left: 26px;
        background-color: ${props.theme.colors.primary};
      }
    ` : ""}

    @media (min-width: 768px) {
      cursor: pointer!important;
    }
`;
export const Switch = (props) => {
    const { onClick: wrapOnClick, ...restWrapper } = props.wrapperProps || {};
    return (React.createElement(SwitchWrapper, { ...restWrapper, onClick: (e) => {
            stopPropagation(e);
            wrapOnClick?.(e);
        } },
        React.createElement(SwitchLabel, { htmlFor: props.id, checked: props.checked, ...props.labelProps, labelColor: props.labelColor, variant: props.variant }),
        React.createElement(SwitchInput, { type: "checkbox", id: props.id, name: props.name, onChange: props.onChange, checked: props.checked, ...props.inputProps })));
};
//# sourceMappingURL=Switch.js.map